<template>
  <div>
    <v-quagga :onDetected="logIt" :readerSize="readerSize" :readerTypes="['code_128_reader', 'code_39_reader', 'upc_reader', 'upc_e_reader']"></v-quagga>
    <pre>
      detectedValue = {{ detectedValue }}
    </pre>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQuagga from 'vue-quaggajs';

// register component 'v-quagga'
Vue.use(VueQuagga);

export default {
  name: 'BarCodeScanner',
  data () {
    return {
      readerSize: {
        width: 640,
        height: 480
      },
      detecteds: [],
      detectedValue: null
    }
  },
  methods: {
    logIt (data) {
      this.detectedValue = data;
    }
  }
}
</script>